export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0029s_0000_Black-&-White-14.4f73a604.png";